import request from '@/utils/request'

/**
 * 分页查询实体列表
 * @param query
 * @param pagination
 * @returns {*}
 */
export function paginationEntity(query = {}, pagination) {
  query.pageNum = pagination.pageNum;
  query.pageSize = pagination.pageSize;
  return request({
    url: `/kl/entity/list`,
    method: 'get',
    params: query
  })
}

// 查询实体管理列表
export function listEntity(query) {
  return request({
    url: '/kl/entity/list',
    method: 'get',
    params: query
  })
}

// 查询所有实体管理列表
export function listAllEntity(query) {
  return request({
    url: '/kl/entity/listAll',
    method: 'get',
    params: query
  })
}

// 查询实体管理详细
export function getEntity(id) {
  return request({
    url: '/kl/entity/' + id,
    method: 'get'
  })
}

// 新增实体管理
export function addEntity(data) {
  return request({
    url: '/kl/entity',
    method: 'post',
    data: data
  })
}

// 修改实体管理
export function updateEntity(data) {
  return request({
    url: '/kl/entity',
    method: 'put',
    data: data
  })
}

// 重置实体客流数据
export function resetTotalPassenger(id) {
  return request({
    url: `/kl/entity/resetTotalPassenger/${id}`,
    method: 'get',
  })
}

// 删除实体管理
export function delEntity(id) {
  return request({
    url: '/kl/entity/' + id,
    method: 'delete'
  })
}

// 删除实体管理
export function bindEntityPassageway(data) {
  return request({
    url: '/kl/entity/bindPassageway',
    method: 'post',
    data:data
  })
}

// 定时计算实体前一天滞留人数
export function jobStatisticsEntityStrand() {
  return request({
    url: '/kl/entity/jobStatisticsEntityStrand',
    method: 'post',
  })
}

// 查询组织和实体混合树
export function stationEntityTree() {
  return request({
    url: '/kl/entity/stationEntityTree',
    method: 'get'
  })
}
